// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const closeButton = "CloseButton__closeButton__3r25Z";
export const small = "CloseButton__small__qSI62";
export const light = "CloseButton__light__JlNSe";
export const danger = "CloseButton__danger__BBwy-";
export const warning = "CloseButton__warning__liBeD";
export const success = "CloseButton__success__ssbk1";
export const action = "CloseButton__action__mfQfQ";